module.exports = __webpack_public_path__ + "media/images/ascleway_logo-da5f3613832f07bdba4cbf90b77c7c9c.jpg";